import { AxiosResponse } from 'axios';
import ApiUrls from '../config/ApiUrls';
import { replaceByObject } from '../utils/Urls';
import API from './Api';
import { PostingApiResponse } from './CalculationApi';

export class PostingApi extends API {
  static create(
    groupId: number,
    entityId: number,
    posting: PostingApiResponse
  ): Promise<PostingApiResponse> {
    return API.post(
      replaceByObject(ApiUrls.EntityPostings, { groupId, entityId }),
      posting
    ).then((response: AxiosResponse<PostingApiResponse>) => {
      return response.data;
    });
  }

  static update(
    groupId: number,
    entityId: number,
    postingId: number,
    posting: PostingApiResponse,
    submit: boolean = false,
    recreate: boolean = false,
    markAsPaid: boolean = false,
    disableAsyncRefresh: boolean = false
  ): Promise<PostingApiResponse> {
    return API.put(
      replaceByObject(ApiUrls.EntityPosting, { groupId, entityId, postingId }),
      posting,
      {
        params: {
          submit,
          recreate,
          markAsPaid,
          disableAsyncRefresh,
        },
      }
    ).then((response: AxiosResponse<PostingApiResponse>) => {
      return response.data;
    });
  }
}
